import * as c from '../constants/GenerateAPIDConstants'

export const getGenerateAPIDData = state => {
  const {
    generateAPID: {
      data: {
        etsExamCd,
        aiCode,
        examDateType,
        mailngAddress,
        serialNumber,
        firstName,
        lastName,
        dob,
      },
    },
  } = state

  return {
    etsExamCd,
    aiCode,
    examDateType,
    mailngAddress,
    serialNumber,
    firstName,
    lastName,
    dob,
  }
}

export const getGenerateAPIDStatusProps = state => {
  const {
    generateAPID: { submitting, submitted, error },
  } = state
  return { submitting, submitted, error }
}

export const getGeneratedAPIDsData = state => {
  const {
    generatedAPIDs: { data = [] },
  } = state
  return data
}

export const getGeneratedAPIDsStatusProps = state => {
  const {
    generatedAPIDs: { fetching, fetched, error },
  } = state
  return { fetching, fetched, error }
}
